export const ConfirmRedirectModalTranslationKeys = {
  confirmRedirectModalDescription: 'common.warning-redirect-description',
  confirmRedirectModalTitle: 'common.warning-redirect-title',
}
